let html = `<div class="plugins-catalog">

    <div class="plugins-catalog__block">
        <div class="plugins-catalog__title selector">#{plugins_catalog_work}</div>
        <div class="plugins-catalog__descr">#{plugins_catalog_work_descr}</div>
        <div class="plugins-catalog__list">
            
        </div>
    </div>

    <div class="plugins-catalog__block">
        <div class="plugins-catalog__title">#{plugins_catalog_popular}</div>
        <div class="plugins-catalog__descr">#{plugins_catalog_popular_descr}</div>
        <div class="plugins-catalog__list">
            
        </div>
    </div>
</div>`

export default html